import { render, staticRenderFns } from "./wechatTencentAdList.vue?vue&type=template&id=6f4c4a8a&scoped=true"
import script from "./wechatTencentAdList.vue?vue&type=script&lang=js"
export * from "./wechatTencentAdList.vue?vue&type=script&lang=js"
import style0 from "./wechatTencentAdList.vue?vue&type=style&index=0&id=6f4c4a8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c4a8a",
  null
  
)

export default component.exports